<span class="alerta__icono">
  <svg app-icono [nombre]="icono()"></svg>
</span>

<div class="alerta__texto">
  @if (titulo(); as encabezado) {
    <strong class="alerta__titulo">{{ encabezado }}</strong>
  }
  <span>{{ mensaje() }}</span>
</div>

<button
  type="button"
  class="alerta__cerrar"
  (click)="cerrada.emit()"
  aria-label="Cerrar aviso"
>
  <svg app-icono nombre="close-icon"></svg>
</button>
